import { createSlice, current } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from 'src/store'
import { AXIOS_DELETE, AXIOS_GET, AXIOS_PATCH, AXIOS_POST } from './service/apiService';
import { ExitChecklistAllStateData } from 'src/types/masters';
import { snackbarGlobConfig } from 'src/globalConfig';

// Initial state for ExitChecklist
const initialState: ExitChecklistAllStateData = {
    exitChecklistList: [],
    exitChecklistTotalCount: 0,
    selectedExitChecklist: null,
    loader: false,
    deleteRecId: null,
    isModalOpen: false,
    formType: 'Add',
    sendMailAlertLWD:null,
};

const slice = createSlice({
    name: 'exitChecklist',
    initialState,
    reducers: {
        setExitChecklistList(
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ exitChecklistList: any[], exitChecklistTotalCount: number, clear: boolean }>
        ) {
            const currentList: any[] = current(state).exitChecklistList;
            state.exitChecklistTotalCount = action.payload.exitChecklistTotalCount;

            if (action.payload.clear) {
                state.exitChecklistList = action.payload.exitChecklistList;
            } else {
                state.exitChecklistList = [...currentList, ...action.payload.exitChecklistList];
            }
        },
        setSelectedExitChecklist(
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ selectedExitChecklist: any }>
        ) {
            state.selectedExitChecklist = action.payload.selectedExitChecklist;
        },
        setModalOpenOrCloseStatus(
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ isModalOpen: boolean }>
        ) {
            state.isModalOpen = action.payload.isModalOpen;
        },
        loader(state: ExitChecklistAllStateData, action: PayloadAction<any>) {
            state.loader = action.payload.loader;
        },
        setDeleteRecordId(
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ deleteRecId: string | number }>
        ) {
            state.deleteRecId = action.payload.deleteRecId;
        },
        setFormType(
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ formType: string }>
        ) {
            state.formType = action.payload.formType;
        },
          setSendMailAlertLWD (
            state: ExitChecklistAllStateData,
            action: PayloadAction<{ sendMailAlertLWD: string | number }>
        ) {
            state.sendMailAlertLWD = action.payload.sendMailAlertLWD;
        },
        


    }
});

export const reducer = slice.reducer;

export const getExitChecklistList =
    (page: number = 0, limit: number = 10, searchKey: string = '',projectId="", clear: boolean = true): AppThunk =>
    async (dispatch) => {
        dispatch(slice.actions.loader({ loader: true }));

        const response: any = await AXIOS_GET(
            `/api/exitStages?page=${page + 1}&limit=${limit}&searchKey=${searchKey}&projectId=${projectId}`, {}, {}
        );

        dispatch(
            slice.actions.setExitChecklistList({
                exitChecklistList: response?.data && response?.data?.list.length ? [...response?.data?.list] : [],
                exitChecklistTotalCount: response?.data?.totalCount || 0,
                clear
            })
        );

        dispatch(slice.actions.loader({ loader: false }));
    };


    export const sendMailLWDAlert =
    (id, snackBar): AppThunk =>
    async (dispatch) => {
        dispatch(slice.actions.loader({ loader: true }));

        const response: any = await AXIOS_GET('/api/exitStages/send-alert-mail/' +id ,null, {});

        dispatch(slice.actions.setSendMailAlertLWD({sendMailAlertLWD:null})
        );

    if (response?.status) {
        snackBar(response?.message, snackbarGlobConfig('success'));
    } else {
        snackBar(response?.message, snackbarGlobConfig('error'));
    }
    dispatch(slice.actions.loader({ loader: false }));
    return response?.status === true ? true : false;

    };


    

export const updateExitChecklist =
    (id, payload, snackBar): AppThunk =>
    async (dispatch) => {
        dispatch(slice.actions.loader({ loader: true }));
        const response: any = await AXIOS_PATCH(
            `/api/exitStages/${id}`, payload , {}
        );
        dispatch(slice.actions.loader({ loader: false }));

        if (response && response.status) {
            snackBar(response?.message, snackbarGlobConfig('success'));
        } else {
            snackBar(response?.message, snackbarGlobConfig('error'));
        }
        return response;
    };

export const createExitChecklist = (payload: any, snackBar: any): AppThunk => async (dispatch) => {
    const response: any = await AXIOS_POST('/api/exitStages/create', payload, {});

    if (response?.data?.id) {
        snackBar(response?.message, snackbarGlobConfig('success'));
        dispatch(slice.actions.setSelectedExitChecklist({ selectedExitChecklist: null }));
        dispatch(slice.actions.setModalOpenOrCloseStatus({ isModalOpen: false }));
    } else {
        snackBar(response?.message, snackbarGlobConfig('error'));
    }

    return response?.data?.id ? true : false;
};

export const getExitChecklistById = (id): AppThunk => async (dispatch) => {
    const response: any = await AXIOS_GET('/api/exitStages/' + id, {}, {});

    dispatch(
        slice.actions.setSelectedExitChecklist({
            selectedExitChecklist: response?.data?.id ? response?.data : null
        })
    );
    dispatch(slice.actions.setModalOpenOrCloseStatus({ isModalOpen: true }));
};

export const deleteExitChecklistById = (id, snackBar: any): AppThunk => async (dispatch) => {
    const response: any = await AXIOS_DELETE('/api/exitStages/' + id, {});
    dispatch(slice.actions.setDeleteRecordId({ deleteRecId: null }));

    if (response?.status) {
        snackBar(response?.message, snackbarGlobConfig('success'));
    } else {
        snackBar(response?.message, snackbarGlobConfig('error'));
    }

    return response?.status === true ? true : false;
};

/* #region custom functions */
export const setDeleteRecordId = (id) => (dispatch) => {
    dispatch(slice.actions.setDeleteRecordId({ deleteRecId: id ? id : null }));
};

export const setFormType = (formType: string = 'Add') => (dispatch) => {
    dispatch(slice.actions.setFormType({ formType }));
};

export const resetEntireForm = () => (dispatch) => {
    dispatch(slice.actions.setSelectedExitChecklist({ selectedExitChecklist: null }));
};

export const setModalOpenOrCloseStatus = (isModalOpen: boolean = false) => (dispatch) => {
    dispatch(slice.actions.setModalOpenOrCloseStatus({ isModalOpen }));
};
/* #endregion custom functions */

export default slice;
